import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { allotMedicineHistory, historyMedicineQuantity } from '../../services/clinic/medicine';
import { formatDateTime } from '../../utils/FormatDateTime';


function MedicineIssueHistory() {
    const navigate = useNavigate();
    const location = useLocation();

    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "Center", key: "center" },
        { label: "Issue Date", key: "created_at" },
        { label: "Issued Quantity", key: "quantity_alloted" },
        { label: "Alloted By", key: "alloted_by" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);


    const pageSize = 10;

    const fetchData = async (id) => {
        setLoading(true);
        try {
            let res = await allotMedicineHistory(id);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch medicines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Medicines:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (location.state) {
            fetchData(location.state.item.id);
        } else {
            navigate('/medicine');
        }
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/invoice' },
            { name: 'Medicines', link: '/medicine' },
            { name: 'Issue History' },
        ]} />
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"Medicine Purchase History Of " + location.state.item.drug_name} />
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                center: <p>{item.center_name || item.center}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                quantity_alloted: <p>{item.quantity_alloted}</p>,
                                alloted_by: <p>{item.alloted_by}</p>,
                            }
                        )
                        )}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
    </>);
}

export default MedicineIssueHistory;